import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kiacarenceonrentinmumbai() {



    const cardData = {





keyword: "Kia Carens On Rent in Mumbai",

headingDescription: "Shreesha Tours & Travels provides premium Kia Carens On Rent in Mumbai for airport transfers, corporate travel, family vacations, business meetings, wedding transportation, outstation trips, sightseeing tours, one-way journeys, and round-trip travel. Our well-maintained Kia Carens offers spacious seating, modern interiors, excellent comfort, advanced safety features, and ample luggage space, making it an ideal choice for families, corporate travelers, and small groups. With experienced chauffeurs, transparent pricing, doorstep pickup, flexible rental packages, and 24/7 customer support, we ensure a safe, comfortable, and hassle-free travel experience. Whether you are planning a weekend getaway, pilgrimage tour, business trip, or long-distance journey, Shreesha Tours & Travels offers dependable Kia Carens rental services in Mumbai with complete convenience and reliability.",

topPlaces: [
  {
    title: "Mumbai to Lonavala",
    description: "Lonavala is a popular hill station known for Tiger Point, Bhushi Dam, Karla Caves, Rajmachi Fort, and lush green valleys, making it a perfect family road trip destination."
  },
  {
    title: "Mumbai to Dapoli",
    description: "Dapoli is a beautiful Konkan destination famous for Murud Beach, Karde Beach, Ladghar Beach, Suvarnadurg Fort, and dolphin spotting tours."
  },
  {
    title: "Mumbai to Bhimashankar",
    description: "Bhimashankar is one of the twelve Jyotirlingas of Lord Shiva and is surrounded by scenic forests, waterfalls, and wildlife sanctuary, making it ideal for religious and nature trips."
  },
  {
    title: "Mumbai to Satara",
    description: "Satara is known for Kaas Plateau, Thoseghar Waterfalls, Sajjangad Fort, Ajinkyatara Fort, and beautiful natural landscapes."
  },
  {
    title: "Mumbai to Ganpatipule",
    description: "Ganpatipule is a famous Konkan pilgrimage and beach destination known for the Swayambhu Ganpati Temple, clean beaches, and coastal beauty."
  },
  {
    title: "Mumbai to Chiplun",
    description: "Chiplun is a scenic town in Konkan famous for Parshuram Temple, Vashishti River, Gowalkot Fort, and lush green surroundings."
  },
  {
    title: "Mumbai to Amboli",
    description: "Amboli is a charming hill station known for waterfalls, viewpoints, misty valleys, trekking trails, and pleasant weather throughout the year."
  },
  {
    title: "Mumbai to Tarkarli",
    description: "Tarkarli is one of Maharashtra's best beach destinations, famous for scuba diving, snorkeling, Sindhudurg Fort, and crystal-clear waters."
  },
  {
    title: "Mumbai to Igatpuri",
    description: "Igatpuri is a peaceful hill station known for Vipassana International Academy, Camel Valley, Bhatsa River Valley, and monsoon landscapes."
  },
  {
    title: "Mumbai to Jawhar",
    description: "Jawhar is a scenic hill station known for Jai Vilas Palace, Dabhosa Waterfall, Hanuman Point, Shirpamal, and rich tribal culture."
  }
],


"services": [
  {
    "name": "Kia Carens On Rent in Mumbai",
    "description": "Book Kia Carens on Rent in Mumbai for comfortable, stylish, and reliable travel with professional chauffeurs and well-maintained AC MUVs. Perfect for airport transfers, family vacations, corporate travel, business meetings, sightseeing tours, weekend getaways, and outstation trips. Enjoy spacious seating, premium interiors, ample luggage space, transparent pricing, and flexible rental packages for hourly, daily, one-way, and round-trip bookings."
  },
  {
    "name": "Kia Carens Rental Mumbai",
    "description": "Choose Kia Carens Rental Mumbai for premium chauffeur-driven travel with modern, spacious, and comfortable vehicles. Our Kia Carens rentals are ideal for airport pickups, office travel, family outings, religious tours, holiday trips, and long-distance journeys, ensuring a smooth and enjoyable ride."
  },
  {
    "name": "Kia Carens Cab Mumbai",
    "description": "Hire Kia Carens Cab Mumbai for dependable local and outstation transportation with experienced drivers and clean AC vehicles. Travel comfortably for corporate meetings, airport transfers, sightseeing, family functions, group travel, and weekend holidays with reliable cab service."
  },
  {
    "name": "Kia Carens Car Hire Mumbai",
    "description": "Book Kia Carens Car Hire Mumbai with professional chauffeurs for hassle-free travel across Mumbai and nearby destinations. Whether for business travel, family vacations, destination weddings, airport transfers, or tourist sightseeing, our Kia Carens rental service offers comfort, safety, and affordability."
  },
  {
    "name": "Kia Carens Taxi Service Mumbai",
    "description": "Choose Kia Carens Taxi Service Mumbai for safe, comfortable, and punctual transportation. Our chauffeur-driven Kia Carens vehicles provide reliable travel for airport transfers, local rides, corporate visits, family outings, and outstation tours with transparent pricing and premium comfort."
  },
  {
    "name": "Kia Carens with Driver Mumbai",
    "description": "Reserve Kia Carens with Driver Mumbai for a relaxing travel experience with skilled and courteous chauffeurs. Enjoy stress-free transportation for business meetings, shopping, sightseeing, airport transfers, family functions, and interstate travel while traveling in a premium MPV."
  },
  {
    "name": "Kia Carens Outstation Cab Mumbai",
    "description": "Book Kia Carens Outstation Cab Mumbai for comfortable long-distance travel across Maharashtra and India. Our spacious AC vehicles are perfect for one-way trips, round trips, family holidays, pilgrimage tours, corporate travel, and multi-city journeys with experienced drivers."
  },
  {
    "name": "Kia Carens Airport Taxi Mumbai",
    "description": "Choose Kia Carens Airport Taxi Mumbai for timely airport pickup and drop services with flight tracking and professional chauffeurs. Enjoy spacious seating, extra luggage capacity, comfortable AC travel, and dependable transportation to and from Mumbai Airport."
  },
  {
    "name": "Kia Carens Family Cab Mumbai",
    "description": "Book Kia Carens Family Cab Mumbai for enjoyable travel with your loved ones. The spacious cabin, comfortable seating, modern features, and experienced chauffeurs make it an excellent choice for vacations, sightseeing, religious tours, family events, and weekend getaways."
  },
  {
    "name": "Best Kia Carens Rental Mumbai",
    "description": "Choose the Best Kia Carens Rental Mumbai for premium chauffeur-driven travel with clean and well-maintained vehicles. Enjoy professional drivers, transparent pricing, flexible booking options, spacious interiors, and dependable service for airport transfers, family vacations, corporate travel, sightseeing tours, destination weddings, business trips, and outstation journeys across Mumbai and throughout India."
  }
],
"tableData": [
  ["Kia Carens On Rent in Mumbai", "Kia Carens Rental Mumbai"],
  ["Kia Carens Cab Mumbai", "Kia Carens Car Hire Mumbai"],
  ["Kia Carens Taxi Service Mumbai", "Kia Carens with Driver Mumbai"],
  ["Kia Carens Outstation Cab Mumbai", "Kia Carens Airport Taxi Mumbai"],
  ["Kia Carens Family Cab Mumbai", "Best Kia Carens Rental Mumbai"]
],




whychoose: [
  {
    WhyChooseheading: "Premium Kia Carens on Rent in Mumbai",
    WhyChoosedescription: "Shreesha Travels offers Kia Carens on rent in Mumbai for families, corporate travellers, airport transfers, outstation trips, sightseeing tours, and special occasions. Enjoy a spacious, stylish, and comfortable MPV with professional chauffeur service."
  },
  {
    WhyChooseheading: "Comfortable MPV for Every Journey",
    WhyChoosedescription: "The Kia Carens is designed for comfortable travel with spacious seating, modern interiors, ample luggage space, and advanced safety features, making it an excellent choice for both city and long-distance travel."
  },
  {
    WhyChooseheading: "Available for Local & Outstation Travel",
    WhyChoosedescription: "Book a Kia Carens for Mumbai city rides, airport pickups and drops, one-way transfers, round trips, business travel, weekend getaways, and outstation tours across Maharashtra and India."
  },
  {
    WhyChooseheading: "Professional Chauffeurs for Safe Travel",
    WhyChoosedescription: "Our experienced drivers ensure punctual pickups, courteous service, safe driving, and a hassle-free journey whether you are travelling within Mumbai or to another destination."
  },
  {
    WhyChooseheading: "Flexible Rental Packages",
    WhyChoosedescription: "Choose from hourly rentals, full-day packages, airport transfers, one-way bookings, round-trip travel, and customized multi-day rental plans according to your travel needs."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Kia Carens",
    WhyChoosedescription: "Every Kia Carens is regularly serviced, sanitized, air-conditioned, and inspected before every trip to provide passengers with a comfortable and reliable travel experience."
  },
  {
    WhyChooseheading: "Perfect for Family & Corporate Travel",
    WhyChoosedescription: "Our Kia Carens rental service is ideal for family vacations, business meetings, employee transportation, hotel transfers, destination weddings, group outings, and airport travel."
  },
  {
    WhyChooseheading: "Book Kia Carens on Rent in Mumbai with Shreesha Travels",
    WhyChoosedescription: "Enjoy affordable rental plans, transparent pricing, professional chauffeur service, and comfortable Kia Carens rentals for every travel requirement in Mumbai."
  }
]

};

const faqData = [
  {
    question: "What is included in Kia Carens rental service in Mumbai?",
    answer: "Shreesha Travels provides chauffeur-driven Kia Carens rentals for local travel, airport transfers, outstation trips, business travel, sightseeing, family tours, and special occasions."
  },
  {
    question: "Can I hire a Kia Carens for outstation travel from Mumbai?",
    answer: "Yes, Kia Carens is available for one-way, round-trip, and multi-day outstation travel across Maharashtra and other states."
  },
  {
    question: "Is Kia Carens suitable for family vacations?",
    answer: "Yes, the Kia Carens offers spacious seating, comfortable interiors, and ample luggage space, making it an ideal choice for family trips."
  },
  {
    question: "Do you provide Kia Carens for Mumbai Airport transfers?",
    answer: "Yes, chauffeur-driven Kia Carens cars are available for airport pickup and drop services from Mumbai Domestic and International Airport."
  },
  {
    question: "Can I rent a Kia Carens for corporate travel?",
    answer: "Yes, our Kia Carens rental service is suitable for business meetings, executive travel, conferences, employee transportation, and corporate events."
  },
  {
    question: "Are professional drivers included with the rental?",
    answer: "Yes, every Kia Carens booking includes a trained and experienced chauffeur for safe and comfortable travel."
  },
  {
    question: "Can I book Kia Carens for weddings and family functions?",
    answer: "Yes, Kia Carens is available for weddings, social events, family gatherings, hotel transfers, and special occasions."
  },
  {
    question: "How is the Kia Carens rental fare calculated?",
    answer: "The rental cost depends on travel distance, trip duration, selected package, waiting time, toll charges, and itinerary."
  },
  {
    question: "Is Kia Carens available for multi-day tours?",
    answer: "Yes, multi-day rental packages are available for vacations, pilgrimage tours, business trips, and customized travel plans."
  },
  {
    question: "How can I book Kia Carens on Rent in Mumbai with Shreesha Travels?",
    answer: "Share your pickup location, travel date, itinerary, passenger details, and rental requirement to receive a customized quotation and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rakesh Nair",
    feedback: "The Kia Carens was perfect for our family holiday. The vehicle was spacious, clean, and the driver ensured a smooth and comfortable journey throughout the trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback: "Excellent rental experience with Shreesha Travels. The Kia Carens was well-maintained, comfortable for long-distance travel, and the booking process was quick and hassle-free.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kia Carens On Rent in Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/kia-carens-on-rent-in-mumbai.webp",
  "description":
    "Book Kia Carens On Rent in Mumbai with Shreesha Tours & Travels for comfortable and reliable taxi services. We provide Kia Carens cabs with experienced drivers for local travel, airport transfers, outstation trips, family vacations, business travel, corporate travel, sightseeing tours, and long-distance journeys with 24x7 booking.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/kia-carens-on-rent-in-mumbai"
  }
};



    return (
        <div>
<Helmet>
  <title>Kia Carens On Rent in Mumbai | Kia Carens Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Kia Carens On Rent in Mumbai with Shreesha Travels for safe and comfortable taxi services. Hire Kia Carens with experienced drivers for local travel, airport transfers, outstation trips, family tours, corporate travel, sightseeing, and 24x7 cab booking."
  />

  <meta
    name="keywords"
    content="Kia Carens On Rent in Mumbai, Kia Carens Rental Mumbai, Kia Carens Cab Mumbai, Kia Carens Car Hire Mumbai, Kia Carens Taxi Service Mumbai, Kia Carens with Driver Mumbai, Kia Carens Outstation Cab Mumbai, Kia Carens Airport Taxi Mumbai, Kia Carens Family Cab, Kia Carens Rental with Driver Mumbai, Kia Carens Cab Booking Mumbai, Kia Carens Hire Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/82.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Kiacarenceonrentinmumbai;